export const SET_SOCIAL_LINKS = 'SET_SOCIAL_LINKS';
export const SET_POSTS = 'SET_POSTS';
